import React from 'react';
import PropTypes from 'prop-types';
import KpiChart from '../../../commons/KpiChart';

const StudentStudyQualityGauge = (props) => (
  <KpiChart
    title="Study Quality"
    description="The number represents the study quality average of students who have studied in the reference month."
    loading={props.loading}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    intervals={[-5, 0, 5, 10, 15]}
    stepSize={5}
    reverseColors={false}
    formatter={props.formatter}
    onClickHistory={props.onClickHistory}
  />
);

StudentStudyQualityGauge.propTypes = {
  loading: PropTypes.bool.isRequired,
  currentValue: PropTypes.number.isRequired,
  previousValue: PropTypes.number.isRequired,
  onClickHistory: PropTypes.func,
  formatter: PropTypes.func.isRequired,
};

StudentStudyQualityGauge.propTypes = {
  onClickHistory: null,
};

export default StudentStudyQualityGauge;
